const state = {
  home: undefined,
  applicationId: undefined
};
export default state;
